import {authState} from "./state";
import {updateAuthStateAction, updateProfileAction} from "./auth.reducer";
import {onInvalidateUserAction, onLookupUserInfoAction, onSignOutAction} from "./auth.effect";

export const models = {
  state: authState,
  reducers: {
    updateAuthStateAction,
    updateProfileAction
  },
  effects: (dispatch) => ({
    invalidateUserAction: async function (_, state) {
      return await onInvalidateUserAction.call(this, dispatch);
    },
    onSignOutAction: async function (_, state) {
      return await onSignOutAction.call(this, dispatch)
    },
    lookupUserInfoAction: async function (_, state) {
      return await onLookupUserInfoAction.call(this, dispatch)
    },
  }),
  selectors: (slice, createSelector, hasProps) => ({
    user() {
      return slice((auth) => auth.user);
    },
    isAuthenticated() {
      return slice((auth) => auth.isAuthenticated);
    },
  }),
};
